import type { TPaymentSystem, TPaymentSystemServer } from '../../store/types';

export const paymentSystemAdapter = (item: TPaymentSystemServer): TPaymentSystem => ({
  id: item.id,
  name: item.name,
  data: JSON.stringify(item.data),
});

export const paymentSystemsAdapter = (items: TPaymentSystemServer[]): TPaymentSystem[] => {
  const paymentsSystem = items.map(paymentSystemAdapter);
  return paymentsSystem;
};
